export const convertFloat32ToInt32 = (floatValue) => {
  const buffer = new ArrayBuffer(4);
  const view = new DataView(buffer);

  view.setFloat32(0, floatValue, true);
  return view.getInt32(0, true);
};

export const convertInt32ToFloat32 = (intValue) => {
  const buffer = new ArrayBuffer(4);
  const view = new DataView(buffer);

  view.setInt32(0, intValue, true);
  return view.getFloat32(0, true);
};
